$(document).ready(function ()  {
    $(document).on('click', '.tm_look_btn', function(e) {
        $('.tm_look_btn').removeClass('active');
        $(this).toggleClass('active');
        $('.lookbook'+$(this).attr('target')).toggleClass('active');
    });
    // Back to top button
    $(".back_to_top").addClass("hidden");
        $(window).scroll(function () {
        if ($(this).scrollTop() === 0) {
            $(".back_to_top").addClass("hidden")
        } else {
            $(".back_to_top").removeClass("hidden")
        }
    });
    $('.back_to_top').click(function () {
        $("html, body").animate({scrollTop: 0}, 600);
        return false;
    });
    });